import React from 'react'
import { NavUser } from '@components/index'

export default function Navbar(): React.ReactElement {
    return (
        <div className="navbar">
            <NavUser />
        </div>
    )
}
